/*
let getTodo = remote.create({url : '/todo'})

@lock(10)
function getData(){
	getTodo()
	.then((res)=>{

	})
}

getData = lock(getData,2,this)

getData(1)
 */

export default function lock<T extends (...args : any[])=> void>(func : T,secondtime=1,context? : any) : (...args : Parameters<T>)=>void {
	let isLocked = false
	return function (this : any,...args : any[]) {
		if(!isLocked){
			isLocked = true
			func.apply(context || this, args)
			setTimeout(() => {
				isLocked = false
			}, secondtime * 1000)
		}
	}
}